// admins type pounds; the API takes whole pence. Exact text parsing (never floating point maths on money):
// "12", "12.5" and "1,250.75" are fine; anything else is refused.
export function parsePounds(text: string): number | null {
  const clean = text.replace(/[£,\s]/g, '');
  const match = clean.match(/^(\d{1,12})(?:\.(\d{1,2}))?$/);
  if (!match) return null;
  return Number(match[1]) * 100 + Number((match[2] ?? '').padEnd(2, '0'));
}
// pence as an editable pounds value, e.g. 150000 → "1500.00"
export const poundsText = (pence: number) =>
  `${Math.trunc(pence / 100)}.${String(Math.abs(pence % 100)).padStart(2, '0')}`;
export const newIdempotencyKey = () => `admin-${crypto.randomUUID()}`;
